// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarItem_root__JgU0_","section":"NavbarItem_section__p_w5c","body":"NavbarItem_body__8md9k","collapse":"NavbarItem_collapse__V3iUL"};